export const locale = {
    lang: 'en',
    data: {
        TOOLBAR: {
            'ACCOUNT_SETTINGS': 'Account settings',
            'LOGOUT': 'Logout',
            'MSG': 'Send a message',
            'MANAGE_PROFILE': 'Manage Qualisys Profile'
        }
    }
}